import { type FC, Suspense } from 'react'

import { lazyIcons } from '@redteclab/icons/lazy'

export const StoryblokIcon: FC<{
  className?: string
  icon?: number | string
}> = ({ className, icon }) => {
  if (typeof icon !== 'string') {
    return null
  }

  const SvgIcon = Object.entries(lazyIcons).find(([key]) => key === icon)?.[1]

  if (!SvgIcon) {
    return null
  }

  return (
    <Suspense>
      <SvgIcon className={className} />
    </Suspense>
  )
}
